import * as colors from './colors'
import * as screen from './screen'
import projects from './projects'
import social from './social'

export { colors, screen, projects, social }



// WEBPACK FOOTER //
// ./src/config/index.js